import { formatDate } from '@dynatrace-sdk/units';

export const formatSeconds = (date: number) =>
  formatDate(date, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3,
  });

export const formatMinute = (date: number) =>
  formatDate(date, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

export const formatHour = (date: number) =>
  formatDate(date, {
    hour: '2-digit',
    minute: '2-digit',
  });

export const formatDay = (date: number) =>
  formatDate(date, {
    hour: '2-digit',
  });

export const formatWeekday = (date: number) =>
  formatDate(date, {
    month: 'short',
    day: 'numeric',
  });

export const formatMonth = (date: number) =>
  formatDate(date, {
    month: 'short',
    day: 'numeric',
  });

export const formatYear = (date: number) =>
  formatDate(date, {
    year: 'numeric',
  });
